/**
 * iDiamonds — oferta de extindere a garanției dintr-o linie de coș.
 *
 * Clickul adaugă produsul-taxă legat de linia curentă, folosind același helper
 * ca pagina de produs. După adăugare coșul se re-randează, iar acest element
 * dispare pentru că snippetul nu-l mai emite pentru linia respectivă.
 */
class WarrantyUpsell extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.warranty-upsell__button');
    if (!this.button) return;

    this._onClick = this._onClick.bind(this);
    this.button.addEventListener('click', this._onClick);
  }

  disconnectedCallback() {
    if (this.button) this.button.removeEventListener('click', this._onClick);
  }

  async _onClick() {
    if (this.button.disabled) return;
    this.button.disabled = true;

    const quantity = parseInt(this.dataset.quantity, 10);

    try {
      await window.iDiamonds.linkedItems.add({
        variantId: this.dataset.variantId,
        quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
        properties: {
          'Extra garanție': this.dataset.productTitle,
          _pentru_varianta: this.dataset.parentVariantId,
        },
      });
    } catch (error) {
      console.error('Garanție — adăugare din coș eșuată:', error);
      this.button.disabled = false;
    }
  }
}

if (!customElements.get('warranty-upsell')) {
  customElements.define('warranty-upsell', WarrantyUpsell);
}
